module.exports = __webpack_public_path__ + "img/undraw_Segment_re_a3e7.a0bea21b.svg";